import React from 'react'
import HowToWork from '../../sections/HowItWorks'
import Layout from '../../component/layout/Layout'

export default function index() {
  return(
    <Layout>
       <HowToWork/>
    </Layout>
  )
}
